















































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import UUIFComponents from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
// import { InfoState } from '@/core';
const cssPrefix = 'pendoConsentDialog';
@Component({
  components:{
    ...UUIFComponents,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwToggle,
  },
})
export default class PendoConsentdDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showPendoConsentModal: boolean;
  pendoTitle: any = this.$t('pendoAnalytics.title');
  enablePendo: boolean = true;

  closeDialog(value:boolean = false) {
    this.$emit('closePendoConsentdDialog', value);
  }

  submitConsent() {
    const params = {
      highlighterNeeded : this.enablePendo ? 'YES' :'NO',
      mode : 'PENDOENABLE',
    };
    this.$store.dispatch('SwQsgStoreStateModule/postDisableQsg', params)
    .then((result) => { // tslint:disable-line
      this.$store.commit('stopLoading');
      if (result.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: result.msgDesc });
        (localStorage as any).setItem('enablePendo', true);
        this.closeDialog(true);
        // messageService.messageManager.showMessage('top-message', `${fwUtilService.apiUtils.parseResponseMessage(response)}`, 'success');
      } else {
        // localStorage.setItem('enablePendoAnalytics', 'NO');
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: result.msgDesc });
        (localStorage as any).setItem('enablePendo', false);
        this.closeDialog(false);
        // fwUtilService.apiUtils.showMessageService(response);
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
      (localStorage as any).setItem('enablePendo', false);
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Error' });
    });
  }

  handlePendoToggle() {}
}
